import React from 'react'
import { MenuBox, SearchInputGroup } from '@maui/elements'

export const DropdownSearch = ({ inputValue, setInputValue }) => {
  return (
    <MenuBox>
      <SearchInputGroup
        flex="1"
        inputProps={{
          onChange: (e) => setInputValue(e.target.value),
          value: inputValue,
          placeholder: 'Filter by Location'
        }}
      />
    </MenuBox>
  )
}
